import Tab from './Tab';
import TabPanel from './TabPanel';

export { Props } from './Tab';
export {
    Tab,
    TabPanel
};
